import React, { useEffect } from "react";
import {
  CustomInputRinforzoNodoProps,
  CustomInputRinforzoNodoValue,
} from "./types";
import { useIntl } from "react-intl";
import { FC_OPTION_VALUES } from "./lib/consts";

import Select from "@ui-components/Select";
import ConnectionCustomInput from "@ui-components/ConnectionCustomInput";
import { FC_OPTIONS, FIELDS } from "./lib/consts";

import _ from "lodash";

export function CustomInputRinforzoNodo({
  value,
  onChange,
}: CustomInputRinforzoNodoProps) {
  // hooks
  const intl = useIntl();

  // utilities
  const update = (
    key: string,
    newValue: any,
    option?: boolean,
    removeKeys?: string[]
  ) => {
    const v = _.omit({ ...(value || {}), [key]: newValue }, removeKeys || []);
    onChange(v as CustomInputRinforzoNodoValue, option);
  };

  return (
    <div className="flex flex-col gap-8">
      {/*@ts-ignore*/}
      <ConnectionCustomInput
        value={value?.compressione}
        label={intl.formatMessage(FIELDS.compressione.localization)}
        symbol={
          <>
            {FIELDS.compressione.symbol}
          </>
        }
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          update(
            "compressione",
            e.target.value ? parseFloat(e.target.value) : null
          );
        }}
        unitOfMeasurement={FIELDS.compressione.mu}
      />
      <div className="flex space-x-4">
        <div className="flex items-center w-1/3">
          {intl.formatMessage(FIELDS.fattore_confidenza.localization)}
        </div>
        <div className="flex w-96 my-2">
        <Select
            className="w-full"
            options={[
              { name: "", value: "" },
              ...Object.entries(FC_OPTION_VALUES).map(([value, name]) => ({
                name,
                value: name,
              })),
            ]}
            value={value?.fattore_confidenza || ""}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
              update(
                "fattore_confidenza",
                e.target.value ? parseFloat(e.target.value) : null,
                true
              );
            }}
          />
        </div>
      </div>

      <ConnectionCustomInput
        value={value?.coefficente_sicurezza}
        label={intl.formatMessage(FIELDS.coefficente_sicurezza.localization)}
        symbol={FIELDS.coefficente_sicurezza.symbol}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          update(
            "coefficente_sicurezza",
            e.target.value ? parseFloat(e.target.value) : null
          );
        }}
        defaultValue={1.15}
      />
      <ConnectionCustomInput
        value={value?.copriferro}
        label={intl.formatMessage(FIELDS.copriferro.localization)}
        symbol={FIELDS.copriferro.symbol}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          update(
            "copriferro",
            e.target.value ? parseFloat(e.target.value) : null
          );
        }}
        unitOfMeasurement={FIELDS.copriferro.mu}
      />
    </div>
  );
}
